// extracted by mini-css-extract-plugin
module.exports = {"divbtn":"MenuDesp_divbtn__XEsgJ","divname":"MenuDesp_divname__nnS66"};